var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.427 9.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.746,0a.581.581,0,0,1,.592.592L1.2,11.387a.619.619,0,0,1-.607.607A.581.581,0,0,1,0,11.4L.139.607A.619.619,0,0,1,.746,0Z",
    transform: "translate(8.481 0) rotate(45)",
    fill: "#282d3d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.592,0A.619.619,0,0,1,1.2.607L1.338,11.4a.581.581,0,0,1-.592.592.619.619,0,0,1-.607-.607L0,.592A.581.581,0,0,1,.592,0Z",
    transform: "translate(0 0.946) rotate(-45)",
    fill: "#282d3d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.51e54e9e.svg";
export { ForwardRef as ReactComponent };